import React from 'react'
import classNames from 'classnames'

export const DoubleChevron = ({ flipped, color = 'currentColor' }) => {
  return (
    <svg viewBox="0 0 24 24" className="double-chevron-toggle">
      <path
        className={classNames('arrow-up', { 'double-chevron-flipped-up': flipped })}
        d="M6 10 L12 4 L18 10"
        strokeWidth="1.5"
        stroke={color}
        fill="none"
      />
      <path
        className={classNames('arrow-down', { 'double-chevron-flipped-down': flipped })}
        d="M18 14 L12 20 L6 14"
        strokeWidth="1.5"
        stroke={color}
        fill="none"
      />
    </svg>
  )
}
